import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';
import { AUTH_ENDPOINT } from '../../config/api';

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};

const ResetPassword = () => {
    const query = useQuery();
    const history = useHistory();
    const [token, setToken] = useState(query.get('token') || '');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState({ type: 'idle', message: '' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!token.trim() || !password) {
            setStatus({ type: 'error', message: 'Token and password are required.' });
            return;
        }
        if (password !== confirmPassword) {
            setStatus({ type: 'error', message: 'Passwords do not match.' });
            return;
        }

        setLoading(true);
        setStatus({ type: 'idle', message: '' });

        try {
            const response = await fetch(`${AUTH_ENDPOINT}/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password })
            });

            if (!response.ok) {
                const payload = await response.json().catch(() => ({}));
                throw new Error(payload.message || 'Unable to reset password.');
            }

            const payload = await response.json();
            setStatus({ type: 'success', message: payload.message || 'Password reset successfully.' });
            setTimeout(() => {
                history.push(`${process.env.PUBLIC_URL || ''}/login`);
            }, 1500);
        } catch (error) {
            setStatus({ type: 'error', message: error.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Styles>
            <div className="main-wrapper login-page">
                <HeaderTwo />
                <BreadcrumbBox title="Reset Password" />

                <section className="login-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="login-box">
                                    <div className="login-title text-center">
                                        <h3>Reset Password</h3>
                                        <p>Enter the token from your email along with a new password.</p>
                                    </div>
                                    {status.type === 'success' && (
                                        <Alert variant="success">{status.message}</Alert>
                                    )}
                                    {status.type === 'error' && (
                                        <Alert variant="danger">{status.message}</Alert>
                                    )}
                                    <form className="form" onSubmit={handleSubmit}>
                                        <p className="form-control">
                                            <label htmlFor="reset_token">Reset Token</label>
                                            <input
                                                type="text"
                                                id="reset_token"
                                                value={token}
                                                onChange={(event) => setToken(event.target.value)}
                                                placeholder="Paste your reset token"
                                                disabled={loading}
                                            />
                                        </p>
                                        <p className="form-control">
                                            <label htmlFor="reset_password">New Password</label>
                                            <input
                                                type="password"
                                                id="reset_password"
                                                value={password}
                                                onChange={(event) => setPassword(event.target.value)}
                                                placeholder="New password"
                                                disabled={loading}
                                            />
                                        </p>
                                        <p className="form-control">
                                            <label htmlFor="reset_confirm">Confirm Password</label>
                                            <input
                                                type="password"
                                                id="reset_confirm"
                                                value={confirmPassword}
                                                onChange={(event) => setConfirmPassword(event.target.value)}
                                                placeholder="Confirm new password"
                                                disabled={loading}
                                            />
                                        </p>
                                        <button type="submit" disabled={loading}>
                                            {loading ? <Spinner animation="border" size="sm" /> : 'Update Password'}
                                        </button>
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
};

export default ResetPassword;
